import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press17',
  templateUrl: './notice-press17.component.html',
  styleUrls: ['./notice-press17.component.scss']
})
export class NoticePress17Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
